import type { ReactNode } from 'react'

export default function Overlay({
  icon,
  iconClass,
  children,
}: {
  icon: ReactNode
  iconClass: string
  children: ReactNode
}) {
  return (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white/[0.94] p-[clamp(20px,3.7vh,48px)] backdrop-blur">
      <div
        className={`mb-[clamp(10px,1.8vh,22px)] flex h-[clamp(40px,7.5vh,64px)] w-[clamp(40px,7.5vh,64px)] items-center justify-center rounded-full border-2 text-[clamp(1rem,1.8vh,1.5rem)] font-semibold ${iconClass}`}
      >
        {icon}
      </div>
      {children}
    </div>
  )
}

export const headlineClass =
  'mb-2.5 text-center font-volte text-[clamp(1.4rem,3.2vh,2rem)] text-primary'
export const subClass =
  'max-w-[320px] text-center text-[clamp(0.78rem,1.5vh,1rem)] leading-[1.65] text-text-mid'
export const amountClass =
  'mt-[clamp(8px,1.5vh,16px)] font-volte text-[clamp(1.8rem,4.5vh,2.8rem)] tracking-[-1.5px] text-primary'
